import { useState, useCallback, useEffect } from 'react';
import {
  checkPassword, loadAdminSession, saveAdminSession,
  clearAdminSession, isAdminPasswordConfigured,
} from '../lib/auth';

export function useAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [promptOpen, setPromptOpen] = useState(false);

  useEffect(() => { setIsAdmin(loadAdminSession()); }, []);

  const login = useCallback((password) => {
    if (checkPassword(password)) {
      saveAdminSession();
      setIsAdmin(true);
      setPromptOpen(false);
      return true;
    }
    return false;
  }, []);

  const logout = useCallback(() => {
    clearAdminSession();
    setIsAdmin(false);
  }, []);

  return {
    isAdmin,
    login,
    logout,
    promptOpen,
    setPromptOpen,
    configured: isAdminPasswordConfigured(),
  };
}
